<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<div>
<p style="text-align: center;">Morrison’s Music</p>
<p style="text-align: center;">Nietzsche</p>
<p style="text-align: center;">Freak words</p>
<p style="text-align: center;">Rush wind</p>
<p style="text-align: center;">Applause</p>
<p style="text-align: center;">Books</p>
<p style="text-align: center;">The poems of death</p>
<p style="text-align: center;">And you</p>
<p style="text-align: center;">Grace</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0e4cc294